import { getSuccessActionType } from "../../utils";
import { CREATE_TIMESLOTS_FROM_SCHEDULE_REQUEST } from "../constants";
import { Action, CreateTimeslotsResponse } from "../types";

export function createTimeslotsResponse(
  state: CreateTimeslotsResponse = {},
  action: Action
): CreateTimeslotsResponse {
  switch (action.type) {
    case getSuccessActionType(CREATE_TIMESLOTS_FROM_SCHEDULE_REQUEST):
      return action.payload;

    default:
      return state;
  }
}
